import { BaseModel } from '../base/base-model'

/**
 * @memberOf loavies.models.user
 * @constructor
 */
export class UserAddressModel extends BaseModel {
  /**
   * @param {string} id
   * @param {string} firstName
   * @param {string} lastName
   * @param {string} countryId
   * @param {string} postcode
   * @param {string} city
   * @param {string} street
   * @param {string} number
   * @param {string} [addition]
   * @param {string} [additionalAddressLine]
   * @param {boolean} [defaultShipping]
   * @param {boolean} [isBusinessAddress]
   */
  constructor({
    id,
    firstName,
    lastName,
    countryId,
    postcode,
    city,
    street,
    number,
    addition,
    additionalAddressLine,
    defaultShipping,
    isBusinessAddress,
  }) {
    super()

    /** @type {string} */
    this.id = id

    /** @type {string} */
    this.firstName = firstName

    /** @type {string} */
    this.lastName = lastName

    /** @type {string} */
    this.countryId = countryId

    /** @type {string} */
    this.postcode = postcode

    /** @type {string} */
    this.city = city

    /** @type {string} */
    this.street = street

    /** @type {string} */
    this.number = number

    /** @type {null|string} */
    this.addition = addition ?? null

    /** @type {null|string} */
    this.additionalAddressLine = additionalAddressLine ?? null

    /** @type {boolean} */
    this.defaultShipping = defaultShipping ?? false

    /** @type {boolean} */
    this.isBusinessAddress = isBusinessAddress ?? false
  }

  /**
   * @return {boolean}
   */
  isValid() {
    return Boolean(this.firstName)
      && Boolean(this.lastName)
      && Boolean(this.street)
      && Boolean(this.number)
      && Boolean(this.postcode)
      && Boolean(this.city)
      && Boolean(this.countryId)
  }
}
